<shared-ui-modal-base-modal
  [cancelButtonTitle]="'button-close' | translate"
  [confirmButtonTitle]="'button-download' | translate"
  [title]="'modal-reason-for-file-downloading-title' | translate"
  [closeOnConfirm]="true"
  [confirmButtonDisabled]="!downloadFormGroup.valid"
  (confirmOutput)="downloadFile()"
>
  <shared-ui-inputs-text-group
    [parentFormGroup]="downloadFormGroup"
    [numRows]="7"
    [formName]="'reason'"
    [name]="'input-reason' | translate"
    [placeholder]="'modal-reason-for-file-downloading-reason' | translate"
    [display]="inputDisplay.Inline"
  ></shared-ui-inputs-text-group>
</shared-ui-modal-base-modal>
